const _center = true
const _padding = {"DEFAULT":"1rem","sm":"1.5rem","lg":"2rem"}
const config = { "center": _center, "padding": _padding,  }
export { config as default, _center, _padding }